export const themeJson = {
  "cssVariables": {},
  "isPanelless": false,
  "completedHtml": "<div>Thank you for your submission! Your form has been submitted successfully.</div>",
  "completeText": "Submit" 
};
